import { Logger } from '@saviynt/common';

import { downloadRdpFileApi } from './api/getDataFromApi';

/**
 * Downloads an RDP file for a given session.
 *
 * @param {Object} options
 * @param {string} options.sessionId - The PAMMS session ID
 * @param {string} [options.workloadIp] - Target server IP/hostname
 * @param {string} [options.port] - Target server port
 * @param {Function} [options.onSuccess] - Callback after successful download
 * @param {Function} [options.onError] - Callback on failure (receives error)
 * @param {Function} [options.onFinally] - Callback that always runs after completion
 */
const downloadRdpSession = ({
  sessionId,
  fileName,
  workloadIp,
  port,
  onSuccess,
  onError,
  onFinally,
}) => {
  if (!sessionId) {
    const error = new Error('sessionId is required for RDP download');

    Logger.error(error);

    if (onError) {
      onError(error);
    }

    if (onFinally) {
      onFinally();
    }

    return;
  }

  // Sanitize fileName: strip path separators and control characters
  const sanitizedFileName = (fileName || 'session').replace(
    /[/\\:*?"<>|\x00-\x1f]/g,
    '_'
  );

  downloadRdpFileApi(sessionId, { workloadIp, port })
    .then((blob) => {
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement('a');

      link.href = url;
      link.download = `${sanitizedFileName}.rdp`;
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);

      if (onSuccess) {
        onSuccess();
      }
    })
    .catch((e) => {
      Logger.error(e);

      if (onError) {
        onError(e);
      }
    })
    .finally(() => {
      if (onFinally) {
        onFinally();
      }
    });
};

export default downloadRdpSession;
